import { useApplicationModals } from "app/common/hooks";
import { Button } from "app/components/atoms/button";
import { InputMolecule } from "app/components/molecules/form";
import { ModalMolecule } from "app/components/molecules/modal";
import { SelectSearchMolecule } from "app/components/molecules/select";
import api from "app/integration/api";
import { useCollector, useUpdateForm } from "app/integration/common/hooks";
import { Formik } from "formik";
import * as Yup from "yup";
import AppModals from ".";

function CreatePurchaseOrderManual({ onSuccess = () => { } }) {
  let isError = false;
  const { showStates, closeModal, getPayloads, openModal, setPayloads } =
    useApplicationModals();
  const payload = getPayloads("purchaseOrder.create-manual");

  const handleClose = () => closeModal("purchaseOrder.create-manual");
  const handleSuccess = () => {
    closeModal("purchaseOrder.create-manual");
    onSuccess();
  };

  const { initialValues, setInitialValues, validationSchema, onSubmit } =
    useUpdateForm({
      initialValues: {
        id: null,
        product_id: null,
        size_variant_id: null,
        color_variant_id: null,
        qty: 0,
        supplier_id: null,
        delivery_date: null
      },
      validationSchema: Yup.object().shape({
        product_id: Yup.number().required("Product harus diisi"),
        size_variant_id: Yup.number().required("Size harus diisi"),
        color_variant_id: Yup.number().required("Color harus diisi"),
        qty: Yup.number().required("Qty harus diisi").min(1, "Qty barang harus lebih dari 0."),
        // delivery_date: Yup.date().required("Delivery date harus diisi"),
      }),
      onSubmit: async (values) => {
        try {
          let purchaseOrderItems = [
            {
              product_id: values.product_id,
              size_variant_id: values.size_variant_id,
              color_variant_id: values.color_variant_id,
              to_order: values.qty,
              supplier_id: values.supplier_id || 0
            }
          ]

          if (values.supplier_id) {
            purchaseOrderItems[0].supplier_id = values.supplier_id;
          }
          await api.purchaseOrder.store(
            values.delivery_date,
            purchaseOrderItems
          );
          isError = false;
        } catch (error) {
          setPayloads("errorMessage.view", {
            title: "Create Purchase Order",
            message: error?.response?.data?.message
              ? error?.response?.data?.message
              : "Server Error",
          });
          isError = true;
          openModal("errorMessage.view");
        }
      },
      onSuccess: !isError && handleSuccess,
    });

  const [products] = useCollector({
    modelName: "product",
  });

  const [productVariants] = useCollector({
    modelName: "productVariant",
  });

  const [suppliers] = useCollector({
    modelName: "supplier",
  });

  return (
    <ModalMolecule
      show={showStates["purchaseOrder.create-manual"]}
      title={`Tambah Pembelian`}
      onClose={handleClose}
    >
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form className="space-y-2" onSubmit={handleSubmit}>
            <SelectSearchMolecule testId="modal-create-purchase-order-manual-product-id-select"
              label="Product"
              name="product_id"
              options={products?.map((item) => ({
                value: item.id,
                label: item.name + " - " + item.code,
              }))}
              onChange={(event) => {
                const value = event.target?.value;
                setFieldValue('product_id', value);
                
                // Get variants for selected product
                const variants = productVariants.filter(item => item.product_id === value);
                
                // Get unique sizes and colors
                const uniqueSizes = [...new Map(variants.map(item => [item.size.id, item.size])).values()];
                const uniqueColors = [...new Map(variants.map(item => [item.color.id, item.color])).values()];
                
                // Set size and color using setFieldValue
                setFieldValue('size_variant_id', uniqueSizes.length > 0 ? uniqueSizes[0].id : null);
                setFieldValue('color_variant_id', uniqueColors.length > 0 ? uniqueColors[0].id : null);
              }}
              onBlur={handleBlur}
              value={values.product_id}
              errorMessage={
                errors.product_id &&
                touched.product_id &&
                errors.product_id
              }
            />
            <SelectSearchMolecule testId="modal-create-purchase-order-manual-size-variant-id-select"
              label="Ukuran"
              name="size_variant_id"
              options={values.product_id
                ? [...new Map(
                  productVariants
                    .filter((item) => item.product_id === values.product_id) // Filter by product_id
                    .map((item) => [item.size.id, { value: item.size.id, label: item.size.name }]) // Buat pasangan key-value dengan key unik
                ).values()]
                : []
              }
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.size_variant_id}
              disabled={!values.product_id}
              errorMessage={
                errors.size_variant_id &&
                touched.size_variant_id &&
                errors.size_variant_id
              }
            />
            <SelectSearchMolecule testId="modal-create-purchase-order-manual-color-variant-id-select"
              label="Warna"
              name="color_variant_id"
              options={values.product_id
                ? [...new Map(
                  productVariants
                    .filter((item) => item.product_id === values.product_id) // Filter by product_id
                    .map((item) => [item.color.id, { value: item.color.id, label: item.color.name }]) // Buat pasangan key-value dengan key unik
                ).values()]
                : []
              }
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={!values.product_id}
              value={values.color_variant_id}
              errorMessage={
                errors.color_variant_id &&
                touched.color_variant_id &&
                errors.color_variant_id
              }
            />
            <InputMolecule testId="modal-create-purchase-order-manual-qty-input"
              label="Qty"
              type="number"
              name="qty"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.qty}
              errorMessage={errors.qty && touched.qty && errors.qty}
            />
            {/* <SelectSearchMolecule testId="modal-create-purchase-order-manual-supplier-id-select"
              label="Supplier"
              name="supplier_id"
              options={suppliers?.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.supplier_id}
              errorMessage={
                errors.supplier_id &&
                touched.supplier_id &&
                errors.supplier_id
              }
            /> */}
            {/* <InputMolecule testId="modal-create-purchase-order-manual-delivery-date-input"
              label="Delivery Date"
              type="date"
              name="delivery_date"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.delivery_date}
              errorMessage={errors.delivery_date && touched.delivery_date && errors.delivery_date}
            /> */}
            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-create-purchase-order-manual-submit-button" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Menyimpan...' : 'Simpan'}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}

export default CreatePurchaseOrderManual;
